// When using this on any file, do the following:
// 1.	Create a new images file. Simply “save as” the original image file as, say images2.js
// 2.	Populate the new image file with new image paths. 
// 3.	Create a new imageGallery file by saving as a new file, say imageGallery3
// 4.	In the new imageGallery file, update the images component you are importing from to the new file path. In this example you are replacing, “./images” with “./images2”
// 5.	In the file you are using this image gallery, be sure to call the right component – from the imageGallery3 file you just created. 


// This is an image gallery. You can call it to any of your pages and use it at will.


import React, { useState } from 'react';  // import the React library
import './imageGallery.css';


export default function Gallery(props) {

    // setting state to establish the main pic
// const [selectedImg, setSelectedImg] = useState(images[0]);

    return(
        <div className="Gallery" style={{marginTop: '-20em', marginBottom: '-20em'}} >
        <div className="container">
            <img src={props.selectedImg} alt="selected" className="selected" />
            <div className="imgContainer">
                {props.images.map((img, index) => (
                    /*looping through the array to populate the thumbnails. */
                    <img 
                        key={index} 
                        src={img} 
                        alt="contianer" 
                        style={{
                            border: props.selectedImg === img ? "4px solid gold" : "" }}
                            /* Where the img = the main image, give it a border. If not, leave it alone. */
                            /** now we useState so onClick for any image updates the main pic to be that image */
                        onClick={() => props.setSelectedImg(img)}    
                     />               
                    
                ))}                    
            </div> 
            </div>
            </div>
);

}